import * as Init from '../init.js';
import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'
import * as SHOW from './show.res.js'

function setKbar(curChart, inData, region) {
    const chartName = 'SHOW.ZDP'
    const chart = curChart.getChart(chartName)

    const curKey = Init.getcurKey()
    inData.keyWord = DATAS.AinfoToKeyWord(inData['info'])
    chart.setKeyWord(curKey, inData.keyWord.static)
    
    const axisXinfo = DATAS.AdateToAxisXinfo(inData['shape'], 'msec')
    // 设置坐标显示信息
    chart.setAxisXinfo(axisXinfo)

    let kbars = SHOW.shapeToKbar(inData['shape'], inData['shape_zdt'])
    chart.setData('KBAR', kbars)

    // 设置界面信息和绑定数据
    const firstLayoutCfg = {
        layout: {
            offset: {
                top: 5,
                bottom: 5,
                left: 5,
                right: 10
            }
        },
        config: CLAPI.Utils.mergeObjectOfDeep({
                zoomInfo: {
                    index: 6,
                },
                title: {
                    // label: "区间标注",
                    label: inData.keyWord.static.name,
                },
                lines: SHOW.show_zdp1_lines,
            },
            CLAPI.ChartRes.CHART_ZOOM_HEAD),
        rectMain: CLAPI.getChartRect(region, 1, 4, 0, 0),
    }
    // 设置 DAY 为该表的数据源
    // 其他为辅助数据 实际运算时
    const firstchart = chart.createChart('user.kbar', 'system.chart', firstLayoutCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        // console.log('KBAR', result)
    })
    chart.bindData(firstchart, 'KBAR')

    const secondLoyoutCfg = {
        layout: {
            offset: {
                top: 5,
                bottom: 5,
                left: 5,
                right: 10
            }
        },
        config: CLAPI.Utils.mergeObjectOfDeep({
            title: {
                label: "涨跌区间",
            },
            axisY: {
                left: {
                    display: 'normal',
                    format: 'integer'
                },
                right: {
                    display: 'normal',
                    format: 'integer'
                }
            },
            lines: SHOW.show_zdp2_lines,
        },
        CLAPI.ChartRes.CHART_ZOOM_MIDDLE),
        rectMain: CLAPI.getChartRect(region, 1, 4, 0, 1)
    }
    const secondchart = chart.createChart('user.degree', 'system.chart', secondLoyoutCfg, function (result) {
        // console.log('VBAR', result)
    })
    chart.bindData(secondchart, 'KBAR')

    const fourLoyoutCfg = {
        layout: {
            offset: {
                top: 5,
                bottom: 5,
                left: 5,
                right: 10
            }
        },
        config: CLAPI.Utils.mergeObjectOfDeep({
            title: {
                label: "涨跌停数",
            },
            axisY: {
                left: {
                    display: 'normal',
                    format: 'integer'
                },
                right: {
                    display: 'normal',
                    format: 'integer'
                }
            },
            lines: SHOW.show_zdp4_lines,
        },
        CLAPI.ChartRes.CHART_ZOOM_MIDDLE),
        rectMain: CLAPI.getChartRect(region, 1, 4, 0, 2)
    }
    const fourchart = chart.createChart('user.zdt', 'system.chart', fourLoyoutCfg, function (result) {
        // console.log('VBAR', result)
    })
    chart.bindData(fourchart, 'KBAR')

    const thirdLayoutCfg = {
        layout: {
            offset: {
                top: 5,
                bottom: 5,
                left: 5,
                right: 10
            }
        },
        config: CLAPI.Utils.mergeObjectOfDeep({
                title: {
                    label: "均值偏离",
                },
                axisY: {
                    left: {
                        display: 'normal',
                        format: 'float'
                    },
                    right: {
                        display: 'normal',
                        format: 'float'                       
                    }
                },
                lines: SHOW.show_zdp3_lines,
            },
            CLAPI.ChartRes.CHART_ZOOM_FOOT),
        rectMain: CLAPI.getChartRect(region, 1, 4, 0, 3)
    }
    const thirdchart = chart.createChart('user.peakr', 'system.chart', thirdLayoutCfg, function (result) {
        // console.log('3Bar', result)
    })
    chart.bindData(thirdchart, 'KBAR')

}

// 画日线
function drawKbar(inData) {

    console.log('Draw ====> show zdp')
    // console.log(JSON.stringify(inData));
    console.log(inData);

    const curChart = Init.getSysChart()
    // 设置为单一窗口 并返回第一个窗口
    curChart.initChart(['SHOW.ZDP'])

    const canvas = Init.canvas
    // 设置第一个窗口
    setKbar(curChart, inData, {
        style:  'splitly',
        top:    0,
        left:   0,
        width:  canvas.width,
        height: canvas.height,
    })

    curChart.onPaint()
}

export function onLoad() {
    // function onLoadData(curKey, inData) {
    //     Init.sendCommand({
    //             cmds: {
    //                 "shape": {
    //                     "cmd": "get",
    //                     "subject": curKey + ".shape_zdp_label",
    //                     "service": "merge/shape",
    //                     "info": {
    //                         "offset": 0,
    //                     }
    //                 },
    //             }
    //         },
    //         function reply(datas) {
    //             if (Init.checkDatas(datas)) {
    //                 drawKbar(datas)
    //             }
    //         });
    // }
    let curKey = Init.getcurKey()
    Init.sendCommand({
            cmds: {
                "info": {
                    "cmd": "get",
                    "subject": curKey + ".alpha_info",
                    "service": "merge/ainfo",
                    "info": {
                        "offset": -1
                    }
                },
                "shape": {
                        "cmd": "get",
                        "subject": curKey + ".shape_zdp_label",
                        "service": "merge/shape",
                        "info": {
                            "offset": 0,
                        }
                },
                "shape_zdt": {
                        "cmd": "get",
                        "subject": curKey + ".shape_zdt_label",
                        "service": "merge/shape",
                        "info": {
                            "offset": 0,
                        }
                },
            }
        },
        function reply(datas) {
            console.log(datas)
            if (Init.checkDatas(datas)) {
                Init.setcurKey(curKey);
                // onLoadData(curKey, datas)
                drawKbar(datas)
            }
        });
}

// 注册方法到参数表